import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET tasks by asset
const serializeArrayParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).map(([key, value]) => {
      if (Array.isArray(value)) {
        return [key, value.join(',')];
      }
      if (typeof value === 'boolean') {
        return [key, value ? 'true' : 'false'];
      }
      return [key, value];
    }),
  );

export const getTasksByAsset = async (assetId, params = {}) => {
  try {
    const formattedParams = serializeArrayParams(params);
    const response = await axiosInstance.get(
      `${API_URL}/tasks/by-asset/${assetId}`,
      { params: formattedParams },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching tasks by asset:", error.response?.data || error);
    throw error;
  }
};

export const assetLifeCycleCostByPeriod = async (assetId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/tasks/asset-life-cycle-cost-by-period/${assetId}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching asset life cycle cost by period:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const getWorkOrderTasksByAsset = async (assetId, params = {}) => {
  try {
    const formattedParams = serializeArrayParams(params);
    const response = await axiosInstance.get(
      `${API_URL}/tasks/by-asset/${assetId}/work-order-options`,
      { params: formattedParams },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching work order tasks by asset:", error.response?.data || error);
    throw error;
  }
};

export const getTasksByPlantRate = async (plantRateId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/tasks/by-plant-rate/${plantRateId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching tasks by plant rate:', error.response?.data || error);
    throw error;
  }
};

// GET all tasks
export const getTasks = async (id) => {
  try {
    if (id === undefined || id === null) {
      const response = await axiosInstance.get(`${API_URL}/tasks`);
      return response.data;
    }
    const response = await axiosInstance.get(`${API_URL}/tasks/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching tasks:", error.response?.data || error);
    throw error;
  }
};

// GET a single tasks
export const getTasksById = async (tasksData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/tasks`, tasksData);
    return response.data;
  } catch (error) {
    console.error("Error fetching tasks:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new tasks
export const createTasks = async (tasksData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/tasks`, tasksData);
    return response.data;
  } catch (error) {
    console.error("Error creating tasks:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing tasks
export const updateTasks = async (id, tasksData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/tasks/${id}`, tasksData);
    return response.data;
  } catch (error) {
    console.error("Error updating tasks:", error.response?.data || error);
    throw error;
  }
};

// DELETE a tasks
export const deleteTasks = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/tasks/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting tasks:", error.response?.data || error);
    throw error;
  }
};

export const copyTasksFromAsset = async (payload) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/tasks/copy-from-asset`, payload);
    return response.data;
  } catch (error) {
    console.error('Error copying tasks from asset:', error.response?.data || error);
    throw error;
  }
};
